// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scanner-form-container {
    background: white;
    border-radius: 10px;
    padding: 30px;
    margin-bottom: 30px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.scanner-form h3 {
    margin: 0 0 20px 0;
    color: #333;
}

.scanner-form .form-group {
    margin-bottom: 20px;
}

.scanner-form .form-group label {
    display: block;
    margin-bottom: 8px;
    color: #555;
    font-weight: 600;
    font-size: 14px;
}

.scanner-form .form-group input,
.scanner-form .form-group select {
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 14px;
    box-sizing: border-box;
}

.scanner-form .form-group input:focus,
.scanner-form .form-group select:focus {
    outline: none;
    border-color: #667eea;
}

.form-actions {
    display: flex;
    gap: 10px;
}

.form-actions button {
    flex: 1 1;
}

.error {
    background: #fee;
    color: #c33;
    padding: 12px;
    border-radius: 5px;
    margin-bottom: 20px;
    font-size: 14px;
}

.customer-list {
    max-height: 200px;
    overflow-y: auto;
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 10px;
    background: #fafafa;
}

.customer-item {
    margin-bottom: 10px;
}

.customer-item:last-child {
    margin-bottom: 0;
}

.customer-item label {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-weight: normal !important;
    padding: 5px;
    border-radius: 3px;
    transition: background 0.2s;
}

.customer-item label:hover {
    background: #e8e8e8;
}

.customer-item input[type="checkbox"] {
    width: auto !important;
    margin: 0 10px 0 0 !important;
    cursor: pointer;
}

.customer-item span {
    flex: 1 1;
}

.form-group small {
    display: block;
    margin-top: 5px;
    color: #666;
    font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ScannerForm.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;;IAEI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,eAAe;AACnB","sourcesContent":[".scanner-form-container {\n    background: white;\n    border-radius: 10px;\n    padding: 30px;\n    margin-bottom: 30px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.scanner-form h3 {\n    margin: 0 0 20px 0;\n    color: #333;\n}\n\n.scanner-form .form-group {\n    margin-bottom: 20px;\n}\n\n.scanner-form .form-group label {\n    display: block;\n    margin-bottom: 8px;\n    color: #555;\n    font-weight: 600;\n    font-size: 14px;\n}\n\n.scanner-form .form-group input,\n.scanner-form .form-group select {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    font-size: 14px;\n    box-sizing: border-box;\n}\n\n.scanner-form .form-group input:focus,\n.scanner-form .form-group select:focus {\n    outline: none;\n    border-color: #667eea;\n}\n\n.form-actions {\n    display: flex;\n    gap: 10px;\n}\n\n.form-actions button {\n    flex: 1;\n}\n\n.error {\n    background: #fee;\n    color: #c33;\n    padding: 12px;\n    border-radius: 5px;\n    margin-bottom: 20px;\n    font-size: 14px;\n}\n\n.customer-list {\n    max-height: 200px;\n    overflow-y: auto;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    padding: 10px;\n    background: #fafafa;\n}\n\n.customer-item {\n    margin-bottom: 10px;\n}\n\n.customer-item:last-child {\n    margin-bottom: 0;\n}\n\n.customer-item label {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    font-weight: normal !important;\n    padding: 5px;\n    border-radius: 3px;\n    transition: background 0.2s;\n}\n\n.customer-item label:hover {\n    background: #e8e8e8;\n}\n\n.customer-item input[type=\"checkbox\"] {\n    width: auto !important;\n    margin: 0 10px 0 0 !important;\n    cursor: pointer;\n}\n\n.customer-item span {\n    flex: 1;\n}\n\n.form-group small {\n    display: block;\n    margin-top: 5px;\n    color: #666;\n    font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
